import _jsx from "@babel/runtime/helpers/jsx";
var _Fragment;
import React from 'react';
import { Heading } from 'reaxl';

/**
 *  The OneClickHeading component displays info specific to the One-Click experience within Email
 */
function OneClickHeading() {
  return _Fragment || (_Fragment = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Heading, {
    size: 400,
    className: "margin-bottom-2"
  }, void 0, "Modify Your One-Click Email Settings"), /*#__PURE__*/_jsx("p", {}, void 0, "Edit your contact details and message to dealers, or change your one-click preference.")));
}
export default OneClickHeading;